import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { MoreHorizontal } from 'lucide-react';
import { IconBookmark } from './Icons';
import { useAuth } from '../context/AuthContext';
import styles from './GNB.module.css';
import Logo from './Logo';

export default function GNB() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, logout, profile } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // 바깥 클릭 / Esc 로 닫기
  useEffect(() => {
    if (!menuOpen) return undefined;
    const onPointerDown = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    const onKeyDown = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [menuOpen]);

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    navigate('/');
  };

  return (
    <nav className={styles.gnb}>
      <div className={styles.inner}>
        <button className={styles.logo} onClick={() => navigate('/')}>
          <Logo className={styles.logoImg} />
        </button>

        <div className={styles.right}>
          {isLoggedIn && (
            <button
              className={styles.navBtn}
              onClick={() => navigate('/scrap')}
              aria-current={location.pathname === '/scrap' ? 'page' : undefined}
              aria-label="저장"
            >
              <IconBookmark size={20} />
            </button>
          )}

          {isLoggedIn && profile && (
            <div className={styles.profileWrap} ref={menuRef}>
              {/* TODO: 프로필 상세 화면이 준비되면 이 블록에 이동을 연결한다 */}
              <div className={styles.profile}>
                {profile.profileImageUrl ? (
                  <img className={styles.avatar} src={profile.profileImageUrl} alt="" />
                ) : (
                  <span className={`${styles.avatar} ${styles.avatarFallback}`}>
                    {profile.nickname?.[0] ?? '?'}
                  </span>
                )}
                <span className={styles.nickname}>{profile.nickname}</span>
              </div>

              <button
                className={`${styles.moreBtn}${menuOpen ? ` ${styles.moreBtnOpen}` : ''}`}
                onClick={() => setMenuOpen((v) => !v)}
                aria-haspopup="menu"
                aria-expanded={menuOpen}
                aria-label="계정 메뉴"
              >
                <MoreHorizontal size={18} strokeWidth={2} />
              </button>

              {menuOpen && (
                <div className={styles.menu} role="menu">
                  <button className={styles.menuItem} role="menuitem" onClick={handleLogout}>
                    로그아웃
                  </button>
                </div>
              )}
            </div>
          )}

          {/* 프로필 조회에 실패해도 로그아웃할 방법은 남겨둔다 */}
          {isLoggedIn && !profile && (
            <button className={styles.outlineBtn} onClick={handleLogout}>로그아웃</button>
          )}

          {/* 로그인이 주 동작이라 채운 버튼으로, 회원가입은 가벼운 텍스트로 둔다.
              채운 버튼은 우측 끝에 와야 시선 흐름과 맞다. */}
          {!isLoggedIn && (
            <>
              <Link className={styles.textBtn} to="/signup" state={{ from: location.pathname }}>회원가입</Link>
              <Link className={styles.solidBtn} to="/login" state={{ from: location.pathname }}>로그인</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
